import { createSlice } from '@reduxjs/toolkit';
import { netSentimentScoreInitialState } from './netSentimentScore.initialState';
import {
  getNetSentimentScore,
  getNetSentimentScoreTrend,
} from './netSentimentScore.actions';

/**
 * Statistics and the source profile never render at the same time, so one box
 * per scope is enough to keep the two surfaces from overwriting each other.
 */
const getBox = (state, action, boxName) =>
  state[action.meta.arg.scope][boxName];

/**
 * Only the latest request for a box may write to it: a fast platform switch can
 * leave an earlier request in flight, and its later `fulfilled` would otherwise
 * overwrite the new platform's score.
 */
const isCurrentRequest = (box, action) =>
  action.meta.requestId === box.pendingRequestId;

const addBoxCases = (builder, thunk, boxName) =>
  builder
    .addCase(thunk.pending, (state, action) => {
      const box = getBox(state, action, boxName);
      box.pendingRequestId = action.meta.requestId;
      box.loading = true;
      box.error = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      const box = getBox(state, action, boxName);
      if (!isCurrentRequest(box, action)) return;
      box.data = action.payload;
      box.loading = false;
      box.error = null;
    })
    .addCase(thunk.rejected, (state, action) => {
      const box = getBox(state, action, boxName);
      if (!isCurrentRequest(box, action)) return;
      box.loading = false;
      box.error = action.payload;
    });

export const netSentimentScoreSlice = createSlice({
  name: 'netSentimentScoreSlice',
  initialState: netSentimentScoreInitialState,
  reducers: {
    resetNetSentimentScore: (state, action) => {
      state[action.payload] = netSentimentScoreInitialState[action.payload];
    },
  },
  extraReducers: (builder) => {
    addBoxCases(builder, getNetSentimentScore, 'index');
    addBoxCases(builder, getNetSentimentScoreTrend, 'trend');
  },
});

export const { resetNetSentimentScore } = netSentimentScoreSlice.actions;
